import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useTranslation } from 'react-i18next';

function DialerPhoneStatus(props) {

    const { t } = useTranslation();
    
    const renderStatus = (data) => {
        let text = "hangup";    

        if (props.dialer.talking) {
            text = "talking";

            if (props.dialer.dialing) {
                text = "dialing";
            }

        }
        return (<Tooltip style={{ position: "fixed" }} {...data}>{t(text)}</Tooltip>);
    }

    const getStatus = () => {
        let content = <FontAwesomeIcon className="px-1 text-muted" size="lg" icon={duotone("phone-hangup")} />
        if (props.dialer.talking) {

            if (props.dialer.dialing) {
                content = <FontAwesomeIcon className="px-1 text-primary" size="lg" icon={duotone("phone-volume")} />
            } else {
                content = <FontAwesomeIcon className="px-1 text-primary" size="lg" icon={duotone("phone-arrow-up-right")} />
            }
        }

        return content;
    }

    return (<OverlayTrigger
        placement="right"
        delay={{ show: 250, hide: 400 }}
        overlay={renderStatus}>
        <div style={{ display: "inline-block" }}>
            {getStatus()}
        </div>
    </OverlayTrigger>);
}


export default DialerPhoneStatus;